import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  ProtocolTypeFilterDto,
  ProtocolTypeItemDto,
  ProtocolTypeService,
} from '@artemis-software/wr-api';
import { CurrentUserService } from '@services/current-user.service';
import { catalogReadOnlyBanner, catalogTenantId, isCatalogReadOnly } from '@/utils/admin-utils';

@Component({
  standalone: false,
  selector: 'wr-protocol-type-overview-page',
  templateUrl: './protocol-type-overview-page.component.html',
  styleUrls: ['./protocol-type-overview-page.component.scss'],
})
export class ProtocolTypeOverviewPageComponent {

  private readonly router = inject(Router);
  private readonly protocolTypeService = inject(ProtocolTypeService);
  private readonly currentUserService = inject(CurrentUserService);
  private readonly fb = inject(FormBuilder);

  readonly tenantId = catalogTenantId();
  readonly catalogReadOnly = isCatalogReadOnly();
  readonly catalogBanner = catalogReadOnlyBanner();
  readonly canCreate = computed(() =>
    this.currentUserService.hasPrivilege('viewProtocolTypes') && !this.catalogReadOnly());

  readonly form: FormGroup;

  readonly loadItems = (filter: ProtocolTypeFilterDto) =>
    this.protocolTypeService.findAll({ ...filter, tenantId: this.tenantId() });
  readonly getCount = (filter: ProtocolTypeFilterDto) =>
    this.protocolTypeService.getCount({ ...filter, tenantId: this.tenantId() });

  constructor() {
    this.form = this.fb.group({
      text: [''],
    });
  }

  navigateToDetail(item: ProtocolTypeItemDto): void {
    this.router.navigate(['protocolTypes', item.id]);
  }

  add(): void {
    this.router.navigate(['protocolTypes', 'new']);
  }
}
